import * as TYPES from './types'

export default {
  setLanguage ({ commit }, obj) {
    commit(TYPES.MAIN_SET_LANGUAGE, obj)
  },
  setAuthIntent ({ commit }, intent) {
    commit(TYPES.MAIN_SET_AUTH_INTENT, intent)
  }
}
